import classNames from 'classnames';

const Infoblock = ({ type, children }: any) => {
  return (
    <div
      className={classNames('border py-3 px-5 rounded-md', {
        ['bg-[#FFFCE1] border-[#D6C000] border-dashed']: type === 'warning',
        ['bg-[#F2DEDE] border-[#EBCCD1] border-solid text-[#A94442]']:
          type === 'error',
        ['bg-[#E4F3F6] border-[#E4F3F6] border-none']: type === 'info',
        ['bg-[#D4EDD9] border-[#D4EDD9] border-none']: type === 'success',
      })}
    >
      {children}
    </div>
  );
};

export default Infoblock;
